import moment from "moment";

const questions = [
        {
          questionId: "Q001",
          question: "Monthly Gross Income",
          answers: [],
          answerKVs: [],
          getValue() {
            return this.awardeeMonthlyGross
          }
        },
        {
          "questionId": "Q002",
          "question": "Income Source",
          "answers": [],
          "answerKVs": [
            {
              "id": "A01",
              "text": "Social Security"
            },
            {
              "id": "A02",
              "text": "Pension"
            },
            {
              "id": "A03",
              "text": "SSI"
            },
            {
              "id": "A04",
              "text": "SSDI"
            },
            {
              "id": "A05",
              "text": "TANF"
            },
            {
              "id": "A06",
              "text": "HEN"
            },
            {
              "id": "A07",
              "text": "ABD"
            },
            {
              "id": "A08",
              "text": "Employment"
            },
            {
              "id": "A09",
              "text": "Other"
            }            
          ],
          addAdditionalAnswers(answerKVs) {
            const data = [];
            this.incomeSourceData.forEach(incomeSource => {
              answerKVs.forEach((val) => {
                let value = val.text;
                if(value === "Social Security") {
                  value = "Social Security (SSA)"
                }
                if(incomeSource.source.includes(value) ) {
                  data.push(val.id);
                  data.push(incomeSource.amount);
                }
              })
            });
            return data;
          }
        },
        {
          "questionId": "Q003",
          "question": "Is the awardee utilizing a time limited short-term rental resource to cover any costs",
          "answers": [],
          "answerKVs": [
            {
              "id": "A01",
              "text": "Yes"
            },
            {
              "id": "A02",
              "text": "No"
            }
          ],
          getValue() { return  this.aShortTermRental}
        },
        {
          "questionId": "Q004",
          "question": "Program / Start Date / End Date / Amount / Notes",
          "answers": [],
          "answerKVs": [
            {
              "id": "A01",
              "text": "ALTSA"
            },
            {
              "id": "A02",
              "text": "AREN"
              },
            {
              "id": "A03",
              "text": "CFS"
              },
              {
              "id": "A04",
              "text": "Diversion"
            },
            {
              "id": "A05",
              "text": "GOSH"
              },
            {
              "id": "A06",
              "text": "HARPS"
              },
              {
              "id": "A07",
              "text": "HEN"
              },
            {
              "id": "A08",
              "text": "LIHEAP"
              },
              {
              "id": "A09",
              "text": "RRH"
            },
            {
              "id": "A10",
              "text": "TAP"
              },
            {
              "id": "A11",
              "text": "VA"
            }
          ],
          getValue() { return  this.awardeeInformation.awardeeRentalAssistanceProgram},
          isRequired() { return this.aShortTermRental === "Yes"},
          addAdditionalAnswers() {
            const amount = this.awardeeInformation.awardeRentalAssisProgramAmount;
            return[
              (this.awardeeInformation.awardeRentalAssisProgramStartDate 
                && this.awardeeInformation.awardeRentalAssisProgramEndDate 
                ? `${moment(this.awardeeInformation.awardeRentalAssisProgramStartDate).format("MM/DD/YYYY")}-${moment(this.awardeeInformation.awardeRentalAssisProgramEndDate).format("MM/DD/YYYY")}` : ''
              ), amount ? parseFloat(amount + "").toFixed(2) : amount, this.awardeeInformation.awardeRentalAssisProgramNotes];
          }
        },
        {
          "questionId": "Q005",
          "question": "Does the awardee have any miscellaneous expenses",
          "answers": [],
          "answerKVs": [
            {
              "id": "A01",
              "text": "Yes"
            },
            {
              "id": "A02",
              "text": "No"
            }
          ],
          getValue() { return  this.aMiscExpenses}
        },
        {
          "questionId": "Q006",
          "question": "Miscellaneous Expense Type - One-time",
          "answers": [],
          "answerKVs": [],
          isRequired(){ return this.aMiscExpenses && (this.aMiscExpenses === "Yes")},
          addAdditionalAnswers() {
            const values = []
            this.awardeeMiscExpenseList.forEach((exp, i) => {
              if(exp.type === 'One-time expense') {
                values.push(exp.expType);
                values.push(exp.amount ? parseFloat(exp.amount + "").toFixed(2) : exp.amount);
              }
            })
            return values;
          }
        },
        {
          "questionId": "Q007",
          "question": "Is the awardee receiving any other housing assistance",
          "answers": [],
          "answerKVs": [
            {
              "id": "A01",
              "text": "Yes"
            },
            {
              "id": "A02",
              "text": "No"
            }
          ],
          getValue() { return  this.aOtherHousingAssist},
          addAdditionalAnswers() {
            const data =[]
            if(this.aOtherHousingAssist === "Yes") {
              data.push(this.housingDescription)
            }
            return data;
          }
        },
        {
          "questionId": "Q008",
          "question": "In which county would you like to live?",
          "answers": [],
          "answerKVs": [
            {
              "id": "A01",
              "text": "Adams"
            },
            {
              "id": "A02",
              "text": "Asotin"
            },
            {
              "id": "A03",
              "text": "Benton"
            },
            {
              "id": "A04",
              "text": "Chelan"
            },
            {
              "id": "A05",
              "text": "Clallam"
            },
            {
              "id": "A06",
              "text": "Clark"
            },
            {
              "id": "A07",
              "text": "Columbia"
            },
            {
              "id": "A08",
              "text": "Cowlitz"
            },
            {
              "id": "A09",
              "text": "Douglas"
            },
            {
              "id": "A10",
              "text": "Ferry"
            },
            {
              "id": "A11",
              "text": "Franklin"
            },
            {
              "id": "A12",
              "text": "Garfield"
            },
            {
              "id": "A13",
              "text": "Grant"
            },
            {
              "id": "A14",
              "text": "Grays Harbor"
            },
            {
              "id": "A15",
              "text": "Island"
            },
            {
              "id": "A16",
              "text": "Jefferson"
            },
            {
              "id": "A17",
              "text": "King"
            },
            {
              "id": "A18",
              "text": "Kitsap"
            },
            {
              "id": "A19",
              "text": "Kittitas"
            },
            {
              "id": "A20",
              "text": "Klickitat"
            },
            {
              "id": "A21",
              "text": "Lewis"
            },
            {
              "id": "A22",
              "text": "Lincoln"
            },
            {
              "id": "A23",
              "text": "Mason"
            },
            {
              "id": "A24",
              "text": "Okanogan"
            },
            {
              "id": "A25",
              "text": "Pacific"
            },
            {
              "id": "A26",
              "text": "Pend Oreille"
            },
            {
              "id": "A27",
              "text": "Pierce"
            },
            {
              "id": "A28",
              "text": "San Juan"
            },
            {
              "id": "A29",
              "text": "Skagit"
            },
            {
              "id": "A30",
              "text": "Skamania"
            },
            {
              "id": "A31",
              "text": "Snohomish"
            },
            {
              "id": "A32",
              "text": "Spokane"
            },
            {
              "id": "A33",
              "text": "Stevens"
            },
            {
              "id": "A34",
              "text": "Thurston"
            },
            {
              "id": "A35",
              "text": "Wahkiakum"
            },
            {
              "id": "A36",
              "text": "Walla Walla"
            },
            {
              "id": "A37",
              "text": "Whatcom"
            },
            {
              "id": "A38",
              "text": "Whitman"
            },
            {
              "id": "A39",
              "text": "Yakima"
            }
          ],
          getValue() { return  this.housingInfo.county}
        },
        {
          "questionId": "Q009",
          "question": "Walker / Wheelchair",
          "answers": [],
          "answerKVs": [
            {
              "id": "A01",
              "text": "A walker"
            },
            {
              "id": "A02",
              "text": "A wheelchair"
            }
          ],
          getValue() { return  this.housingInfo.walkerAndWheelChair},
          isRequired(){return  this.housingInfo.walkerAndWheelChair && this.housingInfo.walkerAndWheelChair.length != 0}
        },
        {
          "questionId": "Q010",
          "question": "Select Type",
          "answers": [],
          "answerKVs": [
            {
              "id": "A01",
              "text": "Manual"
            },
            {
              "id": "A02",
              "text": "Electric"
            }
          ],
          getValue(){ return  this.housingInfo.wheelchairType},
          isRequired(){return  this.housingInfo.walkerAndWheelChair && this.housingInfo.walkerAndWheelChair.includes('A wheelchair')}
        },
        {
          "questionId": "Q011",
          "question": "Width of Chair",
          "answers": [],
          "answerKVs": [
            {
                "id": "A01",
                "text": "18 inches"
            },
            {
                "id": "A02",
                "text": "19 inches"
            },
            {
                "id": "A03",
                "text": "20 inches"
            },
            {
                "id": "A04",
                "text": "21 inches"
            },
            {
                "id": "A05",
                "text": "22 inches"
            },
            {
                "id": "A06",
                "text": "23 inches"
            },
            {
                "id": "A07",
                "text": "24 inches"
            },
            {
                "id": "A08",
                "text": "25 inches"
            },
            {
                "id": "A09",
                "text": "26 inches"
            },
            {
                "id": "A10",
                "text": "27 inches"
            },
            {
                "id": "A11",
                "text": "28 inches"
            },
            {
                "id": "A12",
                "text": "29 inches"
            },
            {
                "id": "A13",
                "text": "30 inches"
            },
            {
                "id": "A14",
                "text": "31 inches"
            },
            {
                "id": "A15",
                "text": "32 inches"
            },
            {
                "id": "A16",
                "text": "33 inches"
            },
            {
                "id": "A17",
                "text": "34 inches"
            },
            {
                "id": "A18",
                "text": "35 inches"
            },
            {
                "id": "A19",
                "text": "36 inches"
            },
            {
                "id": "A20",
                "text": "37 inches"
            },
            {
                "id": "A21",
                "text": "38 inches"
            },
            {
                "id": "A22",
                "text": "39 inches"
            },
            {
                "id": "A23",
                "text": "40 inches"
            },
            {
                "id": "A24",
                "text": "41 inches"
            },
            {
                "id": "A25",
                "text": "42 inches"
            },
            {
                "id": "A26",
                "text": "43 inches"
            },
            {
                "id": "A27",
                "text": "44 inches"
            }
          ],
          isRequired(){return  this.housingInfo.walkerAndWheelChair && this.housingInfo.walkerAndWheelChair.includes('A wheelchair')},
          getValue() { return this.housingInfo.wheelchairWidth}
        },
        {
          "questionId": "Q012",
          "question": "Do you know if you will need to request reasonable modifications and/or accommodations once you obtain housing due to a disability?",
          "answers": [],
          "answerKVs": [
            {
              "id": "A01",
              "text": "Yes"
            },
            {
              "id": "A02",
              "text": "No"
            }
          ],
          getValue() { return  this.housingInfo.modifications}
        },
        {
          "questionId": "Q013",
          "question": "What reasonable accommodations and/or modifications are needed?",
          "answers": [],
          "answerKVs": [],
          isRequired(){return  this.housingInfo.modifications === "Yes"},
          getValue() { return  this.housingInfo.reasonableAccommodations}
        },
        {
          "questionId": "Q014",
          "question": "What size unit is needed",
          "answers": [],
          "answerKVs": [
            {
              "id": "A01",
              "text": "Studio"
            },
            {
              "id": "A02",
              "text": "1 bedroom"
            },
            {
              "id": "A03",
              "text": "2 bedroom"
            },
            {
              "id": "A04",
              "text": "3 bedroom"
            },
            {
              "id": "A05",
              "text": "4+ bedroom"
            }
          ],
          getValue() { return this.housingInfo.unitSize}
        },
        {
          "questionId": "Q015",
          "question": "Other than the head of household, are there any other adults(age 18+) in your household?",
          "answers": [],
          "answerKVs": [
            {
              "id": "A01",
              "text": "Yes"
            },
            {
              "id": "A02",
              "text": "No"
            }
          ],
          getValue() { return this.housingInfo.otherHouseHoldPerson}
        },
        {
          "questionId": "Q016",
          "question": "How many people will be living with you?",
          "answers": [],
          "answerKVs": [],
          getValue() { return this.housingInfo.peopleLiving ? this.housingInfo.peopleLiving : "0"}
        },
        {
          "questionId": "Q017",
          "question": "Do you have any other housing preferences, needs,limitations that will help with housing identification?",
          "answers": [],
          "answerKVs": [],
          addAdditionalAnswers() { return  [this.housingInfo.otherPreferences]}
        },
        {
          "questionId": "Q018",
          "question": "What costs needs to be covered with other resources",
          "answers": [],
          "answerKVs": [],
          getValue() { return  this.additionalInfo.shortTermRentalDetails},
          isRequired() {return this.additionalInfo.shortTermRentalRadio === "Yes"}
        },
        {
          "questionId": "Q019",
          "question": "Do you have someone who helps manage your money?* i.e. a payee",
          "answers": [],
          "answerKVs": [
            {
              "id": "A01",
              "text": "Yes"
            },
            {
              "id": "A02",
              "text": "No"
            }
          ],
          getValue() { return  this.additionalInfo.moneyManagerRadio}
        },
        {
          "questionId": "Q020",
          "question": "Do you if you owe money to a former landlord or Public Houing Authority for unpaid rent or damage",
          "answers": [],
          "answerKVs": [
            {
              "id": "A01",
              "text": "Yes"
            },
            {
              "id": "A02",
              "text": "No"
            }
          ],
          getValue() { return  this.additionalInfo.oweMoneyRadio},
          addAdditionalAnswers() {
            const data = [];
            if(this.additionalInfo.oweMoneyRadio === "Yes") {
              data.push(this.additionalInfo.oweMoneyDetails);
            }
            return data;
          },
        },
        {
          "questionId": "Q021",
          "question": "Do you need short-term rental assistance to cover move-in costs and/or other costs as you work with your case manager to indeitfy and/or obtain permanent affortadble housing?",
          "answers": [],
          "answerKVs": [
            {
              "id": "A01",
              "text": "Yes"
            },
            {
              "id": "A02",
              "text": "No"
            }
          ],
          getValue() {  return this.additionalInfo.shortTermRentalRadio }
        },
        {
          "questionId": "Q022",
          "question": "Miscellaneous Expense Type - Recurring",
          "answers": [],
          "answerKVs": [],
          isRequired(){ return this.aMiscExpenses && (this.aMiscExpenses === "Yes")},
          addAdditionalAnswers() {
            const values = []
            this.awardeeMiscExpenseList.forEach((exp, i) => {
              if(exp.type === 'Recurring expense') {
                values.push(exp.expType);
                values.push(exp.amount ? parseFloat(exp.amount + "").toFixed(2) : exp.amount);
              }
            })
            return values;
          }
        }
      ]

export default questions;